import styled from "styled-components";
import { easyMove } from "../../ClusterMarker/style-constants";

const MarkerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0px;
  height: 0px;
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  transition: transform 0.3s;
  animation: ${easyMove} 0.3s;

  &:hover {
    transform: scale(1.2);
  }
`;

export default MarkerStyled;
